import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import VideoCard from '@/components/feature/VideoCard';
import { getHotVideos } from '@/mocks/videos';

export default function HotRecommend() {
  const { t } = useTranslation();
  const hotVideos = getHotVideos().slice(0, 6);

  return (
    <section className="px-4 md:px-6 py-8 md:py-12 bg-background-50">
      <div className="flex items-center justify-between mb-5 md:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-1 h-5 md:h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            {t('home.hotRecommend')}
          </h2>
        </div>
        <Link
          to="/category/dianshiju"
          className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          {t('home.viewAll')}
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop>
        {hotVideos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}